/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseBannerFeldForm } from './DatabaseBannerFeldForm';
import {
    DatabaseBannerFeldFormFromJSON,
    DatabaseBannerFeldFormFromJSONTyped,
    DatabaseBannerFeldFormToJSON,
} from './DatabaseBannerFeldForm';

/**
 * „Je Feld gibt es abhaengige Einstellungsmoeglichkeiten" (Betreiber
 * 13.09.2026). Nicht jedes Feld kennt jede: Ein Icon hat nur eine
 * Schriftfarbe, ein Button dazu Form, Hintergrund und Rahmen. Was die
 * Maske nicht anbietet, bleibt leer — und was leer ist, kommt aus der
 * Art selbst.
 * @export
 * @interface DatabaseBannerFeldStil
 */
export interface DatabaseBannerFeldStil {
    /**
     * 
     * @type {DatabaseBannerFeldForm}
     * @memberof DatabaseBannerFeldStil
     */
    form?: DatabaseBannerFeldForm;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    hintergrundfarbe?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    rahmenfarbe?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    schriftfarbe?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    schriftart?: string;
    /**
     * NUR BEIM BILD: wie es seine Flaeche fuellt — dieselben Werte wie
     * beim Baustein „Bild aus Bibliothek" (`object-fit`):
     * `scale-down`, `cover`, `contain`, `fill`, `none`.
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    anpassung?: string;
    /**
     * NUR BEIM BILD: welcher Teil zu sehen ist, wenn es beschnitten
     * wird — `object-position`, etwa „center" oder „top left".
     * @type {string}
     * @memberof DatabaseBannerFeldStil
     */
    bildPosition?: string;
}

/**
 * Check if a given object implements the DatabaseBannerFeldStil interface.
 */
export function instanceOfDatabaseBannerFeldStil(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseBannerFeldStilFromJSON(json: any): DatabaseBannerFeldStil {
    return DatabaseBannerFeldStilFromJSONTyped(json, false);
}

export function DatabaseBannerFeldStilFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerFeldStil {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form': !exists(json, 'form') ? undefined : DatabaseBannerFeldFormFromJSON(json['form']),
        'hintergrundfarbe': !exists(json, 'hintergrundfarbe') ? undefined : json['hintergrundfarbe'],
        'rahmenfarbe': !exists(json, 'rahmenfarbe') ? undefined : json['rahmenfarbe'],
        'schriftfarbe': !exists(json, 'schriftfarbe') ? undefined : json['schriftfarbe'],
        'schriftart': !exists(json, 'schriftart') ? undefined : json['schriftart'],
        'anpassung': !exists(json, 'anpassung') ? undefined : json['anpassung'],
        'bildPosition': !exists(json, 'bildPosition') ? undefined : json['bildPosition'],
    };
}

export function DatabaseBannerFeldStilToJSON(value?: DatabaseBannerFeldStil | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form': DatabaseBannerFeldFormToJSON(value.form),
        'hintergrundfarbe': value.hintergrundfarbe,
        'rahmenfarbe': value.rahmenfarbe,
        'schriftfarbe': value.schriftfarbe,
        'schriftart': value.schriftart,
        'anpassung': value.anpassung,
        'bildPosition': value.bildPosition,
    };
}

